import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import { authApi } from "../store/auth/authApi";
import { userAPI } from "../store/user/userApi";
import { reservationsAPI } from "../store/reservations/reservationsApi";
import { userDomAPI } from "../store/user/userDomApi";
import samplesSlice from "../store/brokers/admin/sample/samplesSlice";
import suppliersSlice from "../store/brokers/admin/suppliers/SuppliersSlice";
import purchasesSlice from "../store/brokers/partner/purchases/PurchasesSlice";
import invoicesSlice from "../store/brokers/suppliers/invoices/InvoicesSlice";
import assetsSlice from "../store/brokers/partner/assets/assetsSlice";
import guestsSlice from "../store/brokers/partner/guests/guestsSlice";
import agentActivitiesSlice from "../store/brokers/partner/agent-activities/agentActivitiesSlice";
import { companyUsersApi } from "../store/company-users/companyUsersApi";
import { googleReservationsAPI } from "../store/google-reservations/googleReservationsApi";
import { paymentsAPI } from "../store/payments/paymentsApi";
import { customerExperienceAPI } from "../store/customer-experience/customerExperienceApi";

export const store = configureStore({
  reducer: {
    [userAPI.reducerPath]: userAPI.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [userDomAPI.reducerPath]: userDomAPI.reducer,
    samples: samplesSlice,
    suppliers: suppliersSlice,
    purchases: purchasesSlice,
    invoices: invoicesSlice,
    assets: assetsSlice,
    agentActivities: agentActivitiesSlice,
    guests: guestsSlice,
    [reservationsAPI.reducerPath]: reservationsAPI.reducer,
    [companyUsersApi.reducerPath]: companyUsersApi.reducer,
    [googleReservationsAPI.reducerPath]: googleReservationsAPI.reducer,
    [paymentsAPI.reducerPath]: paymentsAPI.reducer,
	[customerExperienceAPI.reducerPath]: customerExperienceAPI.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      userAPI.middleware,
      authApi.middleware,
      reservationsAPI.middleware,
      companyUsersApi.middleware,
      googleReservationsAPI.middleware,
      paymentsAPI.middleware,
	  customerExperienceAPI.middleware
    ),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
